import { OnboardingEventId } from '@thoughtspot/onboarding-event-service';
import {
    TourChainActionType,
    TourChainStep,
} from './checklist-tour-steps.util';

export const getExploreDashboardsTourChain = (
    taskId: string,
    t: (key: string, params?: Record<string, unknown>) => string,
): TourChainStep[] | null => {
    switch (taskId) {
        case OnboardingEventId.EXPLORE_DASHBOARDS_FIND_YOUR_WAY:
            return [
                {
                    steps: [
                        {
                            target: '[data-tour-id="tour_checklist-popover"]',
                            title: t(
                                'checklistTour.discoverSpotter.findYourWay.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.findYourWay.content',
                            ),
                            disableBeacon: true,
                            placement: 'left-start',
                        },
                    ],
                },
            ];

        case OnboardingEventId.EXPLORE_DASHBOARDS_VIEW_DASHBOARD:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_pinboard_header_info_button"]',
                            title: t(
                                'sparkflow.explore_interactive_dashboard.step1.title',
                            ),
                            content: t(
                                'sparkflow.explore_interactive_dashboard.step1.body',
                            ),
                            disableBeacon: true,
                            placement: 'right-start',
                        },
                    ],
                    onCompleteEventId:
                        OnboardingEventId.EXPLORE_DASHBOARDS_VIEW_DASHBOARD,
                },
            ];

        case OnboardingEventId.EXPLORE_DASHBOARDS_ANALYZE_METRIC_CHANGE:
            return [
                {
                    steps: [
                        {
                            target: '[data-tour-id="tour_explain-change-icon"]',
                            title: t(
                                'sparkflow.analyze_metric_changed.step1.title',
                            ),
                            content: t(
                                'sparkflow.analyze_metric_changed.step1.body',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-start',
                        },
                    ],
                    doneButtonText: t(
                        'sparkflow.analyze_metric_changed.btnText',
                    ),
                    afterAction: {
                        selector: '[data-tour-id="tour_explain-change-icon"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                },
            ];

        case OnboardingEventId.EXPLORE_DASHBOARDS_DRILL_DOWN:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_kpi_sparkline"] g.highcharts-markers path',
                            title: t(
                                'sparkflow.drilldown_granular_info.step1.title',
                            ),
                            content: t(
                                'sparkflow.drilldown_granular_info.step1.body',
                            ),
                            disableBeacon: true,
                            placement: 'top-start',
                        },
                    ],
                    doneButtonText: t(
                        'sparkflow.drilldown_granular_info.btnText',
                    ),
                },
            ];

        case OnboardingEventId.EXPLORE_DASHBOARDS_ASK_FOLLOWUP_QUESTION:
            return [
                {
                    steps: [
                        {
                            target: '[data-tour-id="tour_ask_ai"]',
                            title: t(
                                'sparkflow.spotter_for_eachviz.step1.title',
                            ),
                            content: t(
                                'sparkflow.spotter_for_eachviz.dashboard.step1.body',
                            ),
                            disableBeacon: true,
                            placement: 'right-start',
                        },
                    ],
                    doneButtonText: t('sparkflow.launch_spotter.btnText'),
                    beforeAction: {
                        selector: '[data-tour-id="tour_answer_content"]',
                        type: TourChainActionType.HOVER,
                    },
                    afterAction: {
                        selector: '[data-tour-id="tour_ask_ai"]',
                        type: TourChainActionType.CLICK,
                    },
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_chat_input_container"]',
                            title: t(
                                'sparkflow.spotter_for_eachviz.step2.title',
                            ),
                            content: t(
                                'sparkflow.spotter_for_eachviz.step2.body',
                            ),
                            disableBeacon: true,
                            placement: 'top',
                        },
                    ],
                    showInsideModal: true,
                    dismissOnAction: {
                        selector: '[data-tour-id="tour_conv-assist-send-btn"]',
                        type: TourChainActionType.CLICK,
                    },
                },
            ];

        case OnboardingEventId.EXPLORE_DASHBOARDS_TRACK_TOP_METRICS:
            return [
                {
                    steps: [
                        {
                            target: '[data-tour-id="tour_highlights-button"]',
                            title: t(
                                'sparkflow.track_top_metrics.dashboard.step1.title',
                            ),
                            content: t(
                                'sparkflow.track_top_metrics.dashboard.step1.body',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    doneButtonText: t('sparkflow.track_top_metrics.btnText'),
                    afterAction: {
                        selector: '[data-tour-id="tour_highlights-button"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                },
            ];

        default:
            return null;
    }
};
